import { createFileRoute } from "@tanstack/react-router";

import { SalesOrdersPage } from "../../../workspaces/supply/pages/SalesOrdersPage";

export const Route = createFileRoute("/_console/p/$org/$project/supply/orders")({
  component: SalesOrdersPage,
});
